import { jsx as _jsx } from "react/jsx-runtime";
var AddressView = function (_a) {
    var address = _a.address;
    return (_jsx("span", { children: [(address === null || address === void 0 ? void 0 : address.region) ? address.region : 'NotFound', (address === null || address === void 0 ? void 0 : address.state) ? address === null || address === void 0 ? void 0 : address.state : 'NotFound', (address === null || address === void 0 ? void 0 : address.country) ? address === null || address === void 0 ? void 0 : address.country : 'NotFound']
            .filter(function (x) { return !!x; }).join(", ") }));
};
export default AddressView;
